import styled from 'styled-components';
import PrivacyButton from '~/components/common/privacy-button';
import Button from '~/components/form-elements/button';
import PageErrors from '~/components/page-errors';
import Callout from '~/components/common/callout';
import { Heading1, Heading4, maxWidth, media, spacing, typography } from '~/theme';
import { HRuler, TextParagraph } from '~/theme/elements';
import { rem } from '~/theme/variables/typography';
import PageAlert from '~/components/common/page-alerts';
import Checkbox from '~/components/form-elements/checkbox';

export const BackLinkContainer = styled.div`
    margin-bottom: ${spacing.spacing5};
`;

export const Section = styled.div`
    & h3 {
        margin-top: ${spacing.spacing7};
        margin-bottom: ${spacing.spacing5};
    }
    & h6 {
        margin: ${spacing.spacing5} ${spacing.spacing0} ${spacing.spacing4};
    }
`;

export const PageHeading = styled(Heading1)`
    &:first-of-type {
        margin-top: ${spacing.spacing5};
    }
    border-top: none;
`;

export const StyledButton = styled(Button)`
    margin: ${spacing.spacing5} ${spacing.spacing0} ${spacing.spacing2};
`;

export const SharedButtonSymmetricMargin = styled(Button)`
    margin: ${spacing.spacing7} ${spacing.spacing0} ${spacing.spacing7};
`;

export const FormErrorsContainer = styled.div``;

export const StyledPageErrors = styled(PageErrors)`
    margin-top: ${spacing.spacing7};
`;

export const SharedErrorMessagesContainer = styled.div`
    margin: ${spacing.spacing7} ${spacing.spacing0};
`;

export const SharedButtonNoBottomMargin = styled(Button)`
    margin-bottom: ${spacing.spacing0};
`;

export const StyledPrivacyButton = styled(PrivacyButton)`
    padding-left: 0;
    padding-right: 0;

    svg {
        margin-right: 10px;
    }
`;

export const ActionPlaceholder = styled.span`
    display: inline-block;
    width: 0px;
    height: 29.06px;
    visibility: hidden;
`;

export const SharedMaxWidthForm = styled.form`
    max-width: 657px;

    p {
        @media ${media.medium} {
            max-width: 48rem;
        }
    }
`;

export const CalloutContent = styled.div`
    display: flex;
    flex-wrap: wrap;

    svg {
        width: 24px;
        height: 24px;
        margin-right: ${spacing.spacing1};
    }
`;

export const DurationSpan = styled.span`
    display: inline-flex;
    white-space: pre;
`;

export const CallOutHeading = styled(Heading4)`
    magin: ${spacing.spacing0};
`;

export const AddressChangeCallout = styled(Callout)`
    margin-top: ${spacing.spacing5};
    margin-bottom: ${spacing.spacing5};
    max-width: 732px;
`;

export const AddressChangeCalloutHeadingIcon = styled.div`
    display: inline-block;
    vertical-align: top;
    margin-right: calc(${spacing.spacing4} * 0.95);

    & svg {
        width: 36px;
        height: 36px;
    }
`;

export const AddressChangeCalloutContent = styled(TextParagraph)`
    margin-bottom: ${spacing.spacing0};

    @media ${media.small} {
        margin-left: calc(${spacing.spacing8} + ${spacing.spacing1});
    }
`;

export const PageAlertStyled = styled(PageAlert)`
    margin: ${spacing.spacing7} ${spacing.spacing0};
`;

export const HRulerStyled = styled(HRuler)`
    margin-bottom: ${spacing.spacing7};
`;

export const Container = styled.div`
    margin-top: ${spacing.spacing7};
    div > div {
        margin: 0;
    }
`;

export const CheckboxContainer = styled.div`
    max-width: 811px;
    margin-top: ${spacing.spacing4};
    margin-bottom: ${spacing.spacing5};
`;

export const ConsentContainer = styled.div`
    margin-top: ${spacing.spacing7};
    .checkbox {
        margin-top: ${spacing.spacing3};
        margin-bottom: ${spacing.spacing7};
    }
`;

export const ButtonContainer = styled.div`
    padding-top: ${spacing.spacing3};

    button,
    a[color='primary'] {
        margin-bottom: ${spacing.spacing0};
    }
`;

export const ReviewContainer = styled.div`
    .inforCard {
        margin-bottom: ${spacing.spacing7};
    }

    @media ${maxWidth.small} {
        .isCompact > div:nth-child(2) {
            gap: 0;
        }
    }
`;

export const ContactPhoneInfoRow = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 3fr);
    margin-top: ${spacing.spacing5};
    padding-bottom: ${spacing.spacing5};
    border-bottom: 1px solid #d8d8d8;

    .contactPhoneInfoElement {
        margin-top: ${spacing.spacing0};
        padding-bottom: ${spacing.spacing0};
        border-bottom: 0;
        min-width: 0;
        justify-content: space-between;
    }

    .contactPhoneInfoElement h3 {
        margin-bottom: ${spacing.spacing3};
    }

    .contactPhoneInfoElement .contactPhoneValueRow {
        display: flex;
        align-items: center;
        gap: ${spacing.spacing4};
        min-height: 1.5rem;
    }

    @media ${maxWidth.small} {
        grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);

        .contactPhoneInfoElement h3 {
            min-height: 3.5rem;
            margin-bottom: ${spacing.spacing2};
            align-items: start;
        }
    }
`;

export const ReviewNote = styled(TextParagraph)`
    margin: ${spacing.spacing5} ${spacing.spacing0};
    font-size: calc(${rem(typography.defaultFontSize)} + 0.125rem);
`;

export const StyledCheckbox = styled(Checkbox)`
    label {
        word-wrap: normal;
        word-break: normal;
        -ms-word-break: normal;
        hyphens: none;
        -ms-hyphens: none;
    }
`;

export const CostContainer = styled.div`
    margin-top: ${spacing.spacing7};
`;

export default Section;
